import { FormInputMoney, FormInput } from "@farzoom/common-ui-components";

import { Col, Row, Space, Typography } from "antd";
import { Section } from "../section";
import { PrincipalInfo } from "./principalInfo";
import { GuaranteeDuration } from "./guaranteeDuration";
import { GuaranteeType } from "./guaranteeType";
import { GuaranteeAmount } from "./guaranteeAmount";
import { PurchaseSearch } from "../purchase/purchaseSearch";
import { useFormContext, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { isShowPurchase, setShowPurchaseFields } from "@app/store/purchaseSlice";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { EmailInput } from "@app/UI/emailInput";
import { getValueWithCurrency } from "@utils/currency";

const { Text } = Typography;

export const StartFormBGInfo = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<BgFormInput>();

  const [purchaseNumber, lot, beneficiary] = useWatch({
    control,
    name: ["purchase.purchaseNumber", "purchase.lots.0", "purchase.lots.0.beneficiaries.0"],
  });

  const regNumErr = useRef(false);
  const emailErr = useRef(false);
  const phoneErr = useRef(false);

  const dispatch = useDispatch();
  const isShowPurchaseFields = useSelector(isShowPurchase);

  useEffect(() => {
    regNumErr.current = Boolean(errors?.purchase?.lots?.[0]?.beneficiaries?.[0]?.customerRegNum);
    emailErr.current = Boolean(errors?.purchase?.lots?.[0]?.beneficiaries?.[0]?.email);
    phoneErr.current = Boolean(errors?.purchase?.lots?.[0]?.beneficiaries?.[0]?.phone);
  }, [errors]);

  return (
    <Section title="Сведения о гарантии">
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <GuaranteeType />
          <GuaranteeAmount />
        </Col>
        <Col span={12} />

        <Col span={6}>
          <PurchaseSearch />
        </Col>

        <Col span={6}>
          <FormInputMoney
            name={`purchase.lots.0.beneficiaries.0.bgAmount`}
            control={control}
            setValue={setValue}
            label="Сумма гарантии"
            controls={false}
            required
            maxLength={25}
          />
        </Col>

        <Col span={12}>
          <Row gutter={4}>
            <GuaranteeDuration />
          </Row>
        </Col>

        <Col span={24}>
          <VerticalSpace size={0}>
            <Row gutter={8}>
              {lot?.startAmount && (
                <Col span={9}>
                  <VerticalSpace size={0}>
                    <Text>НМЦК (Начальная (максимальная) цена контракта)</Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {getValueWithCurrency(lot.startAmount, "RUB")}
                    </Text>
                  </VerticalSpace>
                </Col>
              )}
              {lot?.lotSubject && (
                <Col span={15}>
                  <VerticalSpace size={0}>
                    <Text>Предмет контракта</Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {lot.lotSubject}
                    </Text>
                  </VerticalSpace>
                </Col>
              )}
            </Row>

            {beneficiary?.inn && (
              <VerticalSpace size={8}>
                <div>
                  <Text>Бенефициар</Text>
                  <VerticalSpace size={0}>
                    <Text strong style={{ fontSize: 16 }}>
                      {beneficiary.displayName}
                    </Text>
                    <Space>
                      {beneficiary?.inn && <Text type="secondary">ИНН: {beneficiary.inn}</Text>}
                      {beneficiary?.ogrn && <Text type="secondary">ОГРН: {beneficiary.ogrn}</Text>}
                    </Space>
                  </VerticalSpace>
                </div>
                <Row gutter={8}>
                  {regNumErr.current && (
                    <Col span={6}>
                      <FormInput
                        name={`purchase.lots.0.beneficiaries.0.customerRegNum`}
                        control={control}
                        setValue={setValue}
                        label="Регномер бенефициара"
                        required
                      />
                    </Col>
                  )}
                  {phoneErr.current && (
                    <Col span={9}>
                      <FormInput
                        name={`purchase.lots.0.beneficiaries.0.phone`}
                        control={control}
                        setValue={setValue}
                        label="Телефон"
                        placeholder="Введите телефон"
                        required
                      />
                    </Col>
                  )}
                  {emailErr.current && (
                    <Col span={9}>
                      <EmailInput
                        name={`purchase.lots.0.beneficiaries.0.email`}
                        control={control}
                        setValue={setValue}
                        required
                      />
                    </Col>
                  )}
                </Row>
              </VerticalSpace>
            )}
          </VerticalSpace>
        </Col>

        {purchaseNumber && !isShowPurchaseFields && (
          <Col span={24}>
            <Row justify="end">
              <Col>
                <Text
                  underline
                  onClick={() => dispatch(setShowPurchaseFields(true))}
                  style={{ fontSize: 14, color: "var(--ant-primary-color)", cursor: "pointer" }}
                >
                  Подробнее
                </Text>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </Section>
  );
};
